import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/report/loyalty';

const memberSummary = (merchantId, payload) => {
	return Client.get(`${baseUrl}/member/${merchantId}/summary`, payload);
};

const memberJoinTrend = (merchantId, payload) => {
	return Client.get(`${baseUrl}/member/${merchantId}/join-trend`, payload);
};

const depositSummary = (merchantId, payload) => {
	return Client.get(`${baseUrl}/deposit/${merchantId}/summary`, payload);
};

const depositTrend = (merchantId, payload) => {
	return Client.get(`${baseUrl}/deposit/${merchantId}/trend`, payload);
};

const pointSummary = (merchantId, payload) => {
	return Client.get(`${baseUrl}/point/${merchantId}/summary`, payload);
};

const pointTrend = (merchantId, payload) => {
	return Client.get(`${baseUrl}/point/${merchantId}/trend`, payload);
};

export default {
	memberSummary,
	memberJoinTrend,
	depositSummary,
	depositTrend,
	pointSummary,
	pointTrend,
};
